module.exports = __webpack_public_path__ + "img/buy-me-a-coffee-logo-mark-1.06823f7f.svg";